import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Users, Trophy } from 'lucide-react';
import { ReferralSystem, Leaderboard } from '../components';

type Tab = 'referral' | 'leaderboard';

export function ReferralPage() {
  const [activeTab, setActiveTab] = useState<Tab>('referral');

  return (
    <div className="space-y-6">
      {/* Tab selector */}
      <div className="flex gap-2 p-1 bg-white/5 rounded-xl">
        <button
          onClick={() => setActiveTab('referral')}
          className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-lg font-medium transition-all ${
            activeTab === 'referral'
              ? 'bg-primary text-white'
              : 'text-white/60 hover:text-white'
          }`}
        >
          <Users className="w-5 h-5" />
          Referrals
        </button>
        <button
          onClick={() => setActiveTab('leaderboard')}
          className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-lg font-medium transition-all ${
            activeTab === 'leaderboard'
              ? 'bg-primary text-white'
              : 'text-white/60 hover:text-white'
          }`}
        >
          <Trophy className="w-5 h-5" />
          Leaderboard
        </button>
      </div>

      {/* Tab content */}
      <AnimatePresence mode="wait">
        {activeTab === 'referral' && (
          <motion.div
            key="referral"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            className="space-y-6"
          >
            <ReferralSystem />
          </motion.div>
        )}
        {activeTab === 'leaderboard' && (
          <motion.div
            key="leaderboard"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            className="space-y-6"
          >
            <Leaderboard />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
